import { writable, type Writable } from 'svelte/store';

import type { PurchaseRequestState } from '../types';

const createModel = () => {
  const { set, subscribe, update }: Writable<PurchaseRequestState> = writable('default');

  return {
    subscribe,
    set,
    update,
  };
};

export const purchaseRequestModel = createModel();
